export function normalizeText(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

export function encodePathSegment(value = '') {
  return encodeURIComponent(String(value).trim());
}
